module.exports = __webpack_public_path__ + "img/scan-visuals.1e5347c5.png";